export type DeliveryMethod = "generic_post" | "generic_get" | "slack" | "pagerduty" | "datadog";

export interface Webhook {
  name: string;
  vendor: DeliveryMethod;
  url: string;
  api_key?: string;
  api_version: string;
  events: string[];
}

export interface ExistingWebhook extends Webhook {
  id: string;
  created_at: string;
  updated_at: string;
}

export const computeChangedFields = (existingWebhook: ExistingWebhook, updatedWebhook: Webhook): Partial<Webhook> => {
  const changedFields: Partial<Webhook> = {};

  (Object.keys(updatedWebhook) as Array<keyof Webhook>).forEach((key) => {
    if (existingWebhook[key] !== updatedWebhook[key]) {
      changedFields[key] = updatedWebhook[key] as any;
    }
  });

  return changedFields;
};

export const DELIVERY_METHODS: { [key in DeliveryMethod]: string } = {
  generic_post: "HTTP POST",
  generic_get: "HTTP GET",
  slack: "Slack",
  pagerduty: "PagerDuty",
  datadog: "Datadog",
};

export const styleDeliveryMethod = (key: DeliveryMethod) => (
  <span className="flex items-center">
    <span className="mr-1">{DELIVERY_METHODS[key]}</span>
    <span className="truncate text-xs text-gray-500">
      (<span className="text-xs text-gray-400">{key}</span>)
    </span>
  </span>
);

export const EVENT_GROUPS = {
  Transfer: ["transfer.cancelled", "transfer.error", "transfer.success"],
  Source: ["export_source.created", "export_source.updated", "export_source.deleted"],
  Destination: ["export_destination.created", "export_destination.updated", "export_destination.deleted"],
  Recipient: ["recipient.created", "recipient.updated", "recipient.deleted"],
  "Magic Link": ["export_magic_link.created", "export_magic_link.deleted"],
};

export const URL_PLACEHOLDERS = {
  slack: "https://hooks.slack.com/services/YOUR_WEBHOOK_URL",
  pagerduty: "https://events.pagerduty.com/v2/enqueue",
  datadog: "https://api.datadoghq.com/api/v1/events",
  default: "https://example.com/webhook",
};
